import { render, staticRenderFns } from "./realName.vue?vue&type=template&id=9f4e4e6a"
import script from "./realName.vue?vue&type=script&lang=js"
export * from "./realName.vue?vue&type=script&lang=js"
import style0 from "./realName.vue?vue&type=style&index=0&id=9f4e4e6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports